import React from 'react';
import './Loader.css';

function Loader() {
  return (
    <div id="loader-container">
      <div id="loader">
        <div id="circle"></div>
      </div>
    </div>
  );
}

export default Loader;